<template>
  <!-- show payment Modal -->
  <div
      class="modal fade"
      id="permissionModal"
      tabindex="-1"
      aria-labelledby="permissionModal"
      aria-hidden="true"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ permissionProps && permissionProps?.id ? "Edit Permission" : "Save Permission" }}
          </h5>
          <button
              type="button"
              class="close"
              data-bs-dismiss="modal"
              aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div v-if="permission">
            <!-- Restock -->
            <div class="row">
              <div class="col-lg-6 col-sm-12 col-12">
                <div class="form-group">
                  <label>Name</label>
                  <input
                      :min="0"
                      name="stocked"
                      type="text"
                      v-model="permission.name"
                      class="form-control col-6"
                  />
                </div>
              </div>
              <div
                  class="col-lg-6 col-sm-12 col-12"
              >
                <div class="form-group">
                  <label>Code</label>
                  <input
                      :min="0"
                      name="excess_bottles"
                      type="text"
                      v-model="permission.code"
                      class="form-control col-6"
                  />
                </div>
              </div>

              <div class="col-12">
                <div class="form-group">
                  <label>Description(optional)</label>
                  <a-textarea
                      v-model:value="permission.description"
                      show-count
                      :maxlength="200"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-submit" @click="submit()" id="submit">
            Submit
          </button>
          <button primary class="btn btn-cancel" @click="closeModal()">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted, reactive, ref, watch} from "vue";
import {useStore} from "vuex";
import {checkInputValidity} from "@/helpers/validator";
// stores
const store = useStore();

const hasAccess = (access) => store.getters["hasAccess"](access);

// props
const props = defineProps({
  permissionProps: {}
});

const permission = reactive({
  code: "",
  name: "",
  description: "",
});

const emit = defineEmits({
  updateCompleted: () => {
  },
});


watch(
    permission,
    (newVal) => {
      checkInputValidity("submit");
    },
    { immediate: true, deep: true }
);

watch(
    () => props.permissionProps,
    (newPermission) => {
      if (newPermission && newPermission.id) {
        console.log("Permission Props", newPermission);

        permission.code = newPermission.code ?? "";
        permission.name = newPermission.name ?? "";
        permission.description = newPermission.description ?? "";
      } else {
        permission.code = "";
        permission.name = "";
        permission.description = "";
      }
    },
    { immediate: true }
);

async function save() {
  await store.dispatch("adminPermission/add", { payload: permission });
  closeModal();
  store.commit("notify", {
    title: "Success",
    message: "New permission successfully added",
    type: "success",
  });
}
async function update(permissionId) {
  await store.dispatch("adminPermission/update", { id: permissionId, payload: permission });
  closeModal();
  store.commit("notify", {
    title: "Success",
    message: "Permission updated successfully",
    type: "success",
  });
}

async function submit() {
  props.permissionProps?.id ? await update(props.permissionProps.id) : await save();
  emit("updateCompleted");
}

function resetData() {
  permission.name = null;
  permission.code = null;
  permission.description = null;
}

function closeModal() {
  $("#permissionModal").modal("hide");
  resetData();
}

onMounted(() => {
  // $("#permissionModal").on("shown.bs.modal", (event) => {
  //   resetData();
  // });
});
</script>

<style>
.summary {
  border-radius: 5px;
  background: #f0f0f0;
  margin: 10px auto;
  padding: 10px;
}

.summary b {
  font-weight: bold;
}
</style>
